import { useTranslation } from 'react-i18next';
import { useResetSelectionLayer } from '@/hooks/useResetSelectionLayer';
import { useSetAtom } from 'jotai';
import { selectedVideoIdsBaseAtom } from '@/atoms/video';
import { useNavigate } from 'react-router-dom';
import { videoLinkAtom } from '@/atoms/navigation';
import useGetLinkPath from '@/hooks/useGetLinkPath';
import { PlayButton, VideoSport } from '@statsbomb/video-client-js';
import { ErrorBoundary } from '@sentry/react';
import { AuthProtectedComponent } from '@statsbomb/kitbag-auth';

interface PlayVideoButtonProps {
  uuid: string;
  eventId: string;
  period: number;
  gameId: string;
  hasVideoLicence?: boolean;
}

export const PlayVideoButton = ({ uuid, eventId, period, gameId, hasVideoLicence }: PlayVideoButtonProps) => {
  const { t } = useTranslation('video');
  const setSelectedVideoIds = useSetAtom(selectedVideoIdsBaseAtom);
  const resetSelectionLayer = useResetSelectionLayer();
  const navigate = useNavigate();
  const { to, relative } = useGetLinkPath(videoLinkAtom);

  const handleSelect = () => {
    resetSelectionLayer();
    setSelectedVideoIds([{ eventId, videoEventId: uuid }]);

    navigate(to, { relative });
  };

  return (
    <ErrorBoundary>
      <AuthProtectedComponent>
        <PlayButton
          disabled={!hasVideoLicence}
          disabledReason={t('noLicence')}
          icon="Play"
          matchId={gameId}
          onClick={handleSelect}
          period={period}
          size="small"
          sport={VideoSport.Soccer}
          title={t('playVideo')}
          variant="ghost"
        />
      </AuthProtectedComponent>
    </ErrorBoundary>
  );
};
